<template>
    <div>
        <div class="banner">
            <div class="headerReplacementDebtInfo"></div>
            <div class="banner-text">
                <b>ข้อมูลผู้ค้าหลักทรัพย์ (ตั๋วแลกเงิน)</b>
                <div class="breadcrumb">
                    <span><router-link to="/" class="pe-auto">หน้าหลักนักลงทุนสัมพันธ์</router-link></span>
                    <span class="separator"></span>
                    <span>ข้อมูลตราสารหนี้</span>
                    <span class="separator"></span>
                    <span><b>ข้อมูลผู้ค้าหลักทรัพย์ (ตั๋วแลกเงิน)</b></span>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="TabMenu">
                <DebtInfoTabMenu />
            </div>

            <!-- Cards Group - Responsive Layout -->
            <div class="row mt-5 mb-5">
                <!-- Card 1 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column ">
                        <img src="../../assets/bank-icon/kiatnakin-logo.png" class="card-img-top p-3"
                            alt="Kiatnakin Bank Logo">
                        <div class="card-body">
                            <h5 class="card-title">ธนาคารเกียรตินาคินภัทร</h5>
                            <p class="card-text text-body-secondary">เลขที่ 209 อาคารเคเคพี ทาวเวอร์ ถนนสุขุมวิท 21 (อโศก)
                                ถนนสุขุมวิท แขวงคลองเตยเหนือ เขตวัฒนา กรุงเทพฯ 10110 <br>
                                เบอร์โทรศัพท์ : 02-165-5555</p>
                            <a href="https://bank.kkpfg.com/th/home" target="_blank">
                                <button class="w-50 btn btn-outline-primary" type="button">เข้าสู่เว็บไซต์</button>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Card 2 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/scb-logo.png" class="card-img-top p-3" alt="SCB Bank Logo">
                        <div class="card-body">
                            <h5 class="card-title">ธนาคารไทยพาณิชย์ จำกัด (มหาชน)</h5>
                            <p class="card-text text-body-secondary">เลขที่ 9 ถนนรัชดาภิเษก เขตจตุจักร กรุงเทพฯ 10330 <br>
                                เบอร์โทรศัพท์ : 02-544-5740</p>
                            <a href="https://www.scb.co.th/th/personal-banking/" target="_blank">
                                <button class="w-50 btn btn-outline-primary" type="button">เข้าสู่เว็บไซต์</button>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Card 3 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/kbank-logo.png" class="card-img-top p-3" alt="KBANK Logo">
                        <div class="card-body">
                            <h5 class="card-title">ธนาคารกสิกรไทย จำกัด (มหาชน)</h5>
                            <p class="card-text text-body-secondary">เลขที่ 400/22 ถ. พหลโยธิน แขวง สามเสนใน เขตพญาไท
                                กรุงเทพมหานคร 10400 <br>
                                เบอร์โทรศัพท์ : 02-273-3337</p>
                        </div>
                    </div>
                </div>

                <!-- Card 4 -->
                <div class="col-12 col-sm-6 col-md-4 mb-3">
                    <div class="card d-flex flex-column">
                        <img src="../../assets/bank-icon/yuanta-logo.png" class="card-img-top p-3" alt="Yuanta Logo">
                        <div class="card-body">
                            <h5 class="card-title">บริษัทหลักทรัพย์หยวนต้า (ประเทศไทย) จำกัด</h5>
                            <p class="card-text text-body-secondary">เลขที่ 127 อาคารเกษร ทาวเวอร์ ชั้น 14-16 ถนนราชดำริ
                                แขวงลุมพินี เขตปทุมวัน กรุงเทพฯ 10330 <br>
                                เบอร์โทรศัพท์ : 02-009-8889</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import DebtInfoTabMenu from '@/components/DebtInfoTabMenu.vue';
import Highcharts from 'highcharts';
import store from "@/store";
import { mapState } from "vuex";
import { GET_FINANCIAL_DATA } from "../../store/actions.type";

export default {
    name: 'Info',
    components: {
        DebtInfoTabMenu,
    },
    data() {
        return {
            financialData: null,
        };
    },
    methods: {
        async init() {
            let response = await store.dispatch(GET_FINANCIAL_DATA);
            if (response) {
                this.financialData = response; // Assign fetched data to local state
            } else {
                console.error('Failed to fetch financial data');
            }
        },
    },

};
</script>
<style scoped>
.card {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.card-body {
    flex-grow: 1;
}
</style>
  